import React, { useContext, useEffect, useState } from 'react';
import { all } from '../../../app/data/validate';

import FireDataContext from '../../../services/firebase/FireDataContext';
import { getContactList } from './XeroContactApi';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import MemberWaiting from '../../members/_common/MemberWaiting';
import XeroLinkOrganizationContent from './XeroLinkOrganizationContent';

const XeroLinkOrganizationPage = () => {
    const db = useContext(FireDataContext);
    const [organizations, setOrganizations] = useState();
    const [contacts, setContacts] = useState();

    useEffect(() => {

        getContactList()
            .then(setContacts)
            .catch(error => console.log(error));

        db.get({ path: 'organizations' })
            .then(setOrganizations)
            .catch(error => console.log(error));

    }, [db]);

    if (!all(organizations, contacts)) return <MemberWaiting />;

    const handleUpdate = ({ organization, contact }) => {
        // we could just go back to the database and api but that seems like overkill 
        // so just update the local data so the filters work
        setOrganizations(organizations.map(o => {
            return o.id === organization.id ? { ...o, xeroContactId: organization.xeroContactId } : o;
        }));

        setContacts(contacts.map(c => {
            return c.ContactID === contact.ContactID ? { ...c, AccountNumber: contact.AccountNumber } : c;
        }))
    }

    return (
        <MemberMiniMenu>
            <XeroLinkOrganizationContent 
                db={db}
                onUpdate={handleUpdate}
                organizations={organizations}
                contacts={contacts}
            />
        </MemberMiniMenu>
    );

};

export default XeroLinkOrganizationPage;